import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'antd';
import { FieldArray } from 'formik';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getOptionsByPath } from '../../../utilsdata';
import { InputField, SelectInput } from '../../../blueplanitUtils/InputField';
import { EXISTING_POLICY_INFO, REQUEST_PERSONAL_LINE } from '../../../Dropdownmanager.jsx';
import { NEW_QUOTE, ELIGIBILITY, INSURANCE_CARRIER, COMMERCIAL_POLICY_INFO, COMMERCIAL_LINE } from '../../../Dropdownmanager.jsx';

const NewQuoteInformation = (props) => {

    const { handleChange, values } = props;

    const [remarks, setRemarks] = useState([]);

    const [quotePremium, setQuotePremium] = useState([]);

    useEffect(() => {
        if (values.newQuoteInformation) {
            setRemarks(values.newQuoteInformation?.map(quote => quote.remarks));
        }
    }, [values.newQuoteInformation]);

    useEffect(() => {
        if (values.newQuoteInformation) {
            setQuotePremium(values.newQuoteInformation.map(quote => quote.quotedPremium));
        }
    }, [values.newQuoteInformation]);

    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const personalOptions = getOptionsByPath(NestedDatabucket, [EXISTING_POLICY_INFO, REQUEST_PERSONAL_LINE]);
    const commercialOptions = getOptionsByPath(NestedDatabucket, [COMMERCIAL_POLICY_INFO, COMMERCIAL_LINE]);
    const Eligibility = getOptionsByPath(NestedDatabucket, [NEW_QUOTE, ELIGIBILITY]);

    const handleAddRow = (arrayHelpers) => {
        arrayHelpers.push({
            policy: '',
            insuranceCarrier: '',
            eligibility: '',
            quotedPremium: '',
            remarks: '',

        });
        setRemarks((prevRemarks) => [...prevRemarks, '']);
        setQuotePremium((prevQuoted) => [...prevQuoted, '']);
    };

    const handleDeleteRow = (index, arrayHelpers) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this QuoteInformation?");
        if (confirmDelete) {
            arrayHelpers.remove(index);
            setRemarks((prevRemarks) => prevRemarks.filter((_, i) => i !== index));
            setQuotePremium((prevQuoted) => prevQuoted.filter((_, i) => i !== index));
        }
    };

    return (<>
        <Form layout="vertical">
            <h5 className="card-title" style={{ fontWeight: 'bold' }}>New Quote Information</h5>
            <div className="mb-3">
                <hr />
            </div>

            <FieldArray
                name="newQuoteInformation"
                render={(arrayHelpers) => (
                    <>
                        {values?.newQuoteInformation?.map((quote, index) => (
                            <div key={index} className="new-quote-row">

                                {/* Quote No - first line */}
                                <div className="" style={{ marginLeft:'-25px', marginTop:'-5px'}}>
                                    <span className="new-quote-label">Quote No.</span>
                                    <div className="new-quote-input">{index + 1}</div>
                                </div>

                                {/* Row 1: Policy Type | Eligibility */}
                                <div className="new-quote-grid-row">
                                    <div className="new-quote-field-row">
                                        <span className="new-quote-label" style={{ marginRight:'-20px', marginTop:'-20px'}}>Policy Type</span>
                                        <div className="new-quote-input">
                                            <SelectInput
                                            style={{ marginLeft:'15px'}}
                                                value={quote.policy}
                                                onChange={(value) =>
                                                    handleChange({ target: { name: `newQuoteInformation.${index}.policy`, value } })
                                                }
                                                options={
                                                    (values.processType === 'Policy Quoting' && values.department === 'Commercial Lines')
                                                        ? commercialOptions
                                                        : personalOptions
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="new-quote-field-row">
                                        <span className="new-quote-label" style={{ marginTop:'-20px'}}>Eligibility</span>
                                        <div className="new-quote-input">
                                            <SelectInput
                                                placeholder="select eligibility"
                                                value={quote.eligibility}
                                                onChange={(value) =>
                                                    handleChange({ target: { name: `newQuoteInformation.${index}.eligibility`, value } })
                                                }
                                                options={Eligibility?.map((item) => ({ value: item.value, label: item.label }))}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Row 2: Insurance Carrier | Quoted Premium / Remarks */}
                                <div className="new-quote-grid-row" style={{ marginTop:'-25px'}}>
                                    <div className="new-quote-field-row">
                                        <span className="new-quote-label" style={{ marginTop:'-20px'}}>Insurance Carrier</span>
                                        <div className="new-quote-input">
                                            <SelectInput
                                            style={{ marginLeft:'15px'}}
                                                value={quote.insuranceCarrier}
                                                onChange={(value) =>
                                                    handleChange({ target: { name: `newQuoteInformation.${index}.insuranceCarrier`, value } })
                                                }
                                                options={getOptionsByPath(NestedDatabucket, [NEW_QUOTE, INSURANCE_CARRIER])}
                                            />
                                        </div>
                                    </div>

                                    <div className="new-quote-field-row" style={{ marginTop:'-10px'}}>
                                        <span className="new-quote-label">{quote.eligibility === 'Eligible' ? 'Quoted Premium' : 'Remarks'}</span>
                                        <div className="new-quote-input">
                                            <InputField
                                                style={{ marginTop:'-10px'}}
                                                value={quote.eligibility === 'Eligible' ? quotePremium[index] || '' : remarks[index] || ''}
                                                onChange={(e) => {
                                                    if (quote.eligibility === 'Eligible') {
                                                        const updated = [...quotePremium];
                                                        updated[index] = e.target.value;
                                                        setQuotePremium(updated);
                                                    } else {
                                                        const updated = [...remarks];
                                                        updated[index] = e.target.value;
                                                        setRemarks(updated);
                                                    }
                                                }}
                                                onBlur={(e) =>
                                                    handleChange({
                                                        target: {
                                                            name:
                                                                quote.eligibility === 'Eligible'
                                                                    ? `newQuoteInformation[${index}].quotedPremium`
                                                                    : `newQuoteInformation[${index}].remarks`,
                                                            value: e.target.value,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Delete Icon */}
                                <Link to="#" className="delete-icon" style={{ fontSize:'14px', color: '#d32f2f'}} onClick={() => handleDeleteRow(index, arrayHelpers)}>
                                    <i className="fa-regular fa-trash-can" />
                                </Link>
                            </div>
                        ))}

                        {/* Add More link */}
                        <Form.Item className="new-quote-add-more">
                            <Link to="#" onClick={() => handleAddRow(arrayHelpers)} style={{ fontSize:'12px'}}>
                                <i className="fa-solid fa-plus-circle"/> Add More
                            </Link>
                        </Form.Item>
                    </>
                )}
            />

        </Form>


    </>);
};

export default NewQuoteInformation;
